/* ROVIA 安心導線
   ・お届け予定日は商品ページ・カート・コーデページでは表示しない（10/30 本人の判断）。お届け日数は特商法・配送ページ・よくある質問に記載
     （[data-rv-eta] があれば、土日・祝日・年末を除いた営業日で「10/30(金)〜11/20(金)ごろ」の形で表示する仕組みは残している）
   ・カート（ドロワー／カートページ）：「送料」と「お支払い合計（税込・送料込み）」をはっきり表示し、決済前の安心メモを添える
     （カゴ落ち理由の1位は送料などの追加費用 48%、合計金額が事前にわからない 16%：Baymard）
   ・うその表示はしない（在庫数・閲覧人数・期限などの作り話は出さない）
   ※送料・送料無料ライン・お届け日数を変えたら GOAL / FEE / MIN / MAX と snippets/rv-buy-info.liquid、sections/jd-settings.liquid も直すこと */
(function () {
  'use strict';
  var GOAL = 5980, FEE = 870, MIN = 5, MAX = 20;

  // 日本の祝日・年末（2026年11月〜2027年12月）。2028年以降は土日だけを除いて計算
  var OFF = {};
  ['2026-11-03', '2026-11-23', '2026-12-29', '2026-12-30', '2026-12-31',
    '2027-01-01', '2027-01-11', '2027-02-11', '2027-02-23', '2027-03-22', '2027-04-29',
    '2027-05-03', '2027-05-04', '2027-05-05', '2027-07-19', '2027-08-11', '2027-09-20',
    '2027-09-23', '2027-10-11', '2027-11-03', '2027-11-23', '2027-12-29', '2027-12-30', '2027-12-31'
  ].forEach(function (d) { OFF[d] = 1; });
  var W = ['日', '月', '火', '水', '木', '金', '土'];
  function pad(n) { return ('0' + n).slice(-2); }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function addBizDays(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && !OFF[key(d)]) n--;
    }
    return d;
  }
  function fmt(d) { return (d.getMonth() + 1) + '/' + d.getDate() + '(' + W[d.getDay()] + ')'; }
  var ETA = fmt(addBizDays(MIN)) + '〜' + fmt(addBizDays(MAX)) + 'ごろ';
  function yen(n) { return '¥' + Math.max(0, Math.round(n)).toLocaleString('ja-JP'); }

  var P = {
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 018 0v3"/>',
    card: '<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="M3 10h18M7 15h4"/>',
    ret: '<path d="M4 10h11a5 5 0 010 10H9"/><path d="M8 6l-4 4 4 4"/>',
    truck: '<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/>',
    shield: '<path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M8.5 12l2.3 2.3L15.5 9.6"/>'
  };
  function ic(n) {
    return '<svg class="rv-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + P[n] + '</svg>';
  }

  var PAYNOTE = 'PayPay・コンビニ払いなどは、お支払い画面で「Pay via Cards/Wallets/Bank Transfer」を選ぶと表示されます';

  var ASSURE_DRAWER =
    '<ul class="rv-assure rv-assure--cart" role="list">' +
      '<li>' + ic('lock') + '<span>次の画面で注文内容を確認できます（まだ注文は確定しません）</span></li>' +
      '<li>' + ic('card') + '<span>カード・PayPay・コンビニ払いOK<small>' + PAYNOTE + '</small></span></li>' +
    '</ul>';

  var ASSURE_PAGE =
    '<ul class="rv-assure rv-assure--cart" role="list">' +
      '<li>' + ic('lock') + '<span>次の画面で注文内容を確認できます（まだ注文は確定しません）</span></li>' +
      '<li>' + ic('shield') + '<span>お支払いはSSL暗号化通信で保護。カード番号が当店に保存されることはありません</span></li>' +
      '<li>' + ic('ret') + '<span>サイズが合わなければ交換OK（到着後7日以内・1回・手数料¥870）。不良・間違いは送料当店負担で交換・返金</span></li>' +
      '<li>' + ic('truck') + '<span>発送後、追跡番号をメールでお知らせします</span></li>' +
    '</ul>' +
    '<div class="rv-paybox">' +
      '<p class="rv-paybox__title">ご利用いただけるお支払い方法</p>' +
      '<p>クレジットカード（Visa・Mastercard・AMEX・JCB）／PayPay／楽天ペイ／メルペイ／コンビニ払い（セブン-イレブン・ファミリーマート・ローソン・ミニストップ・デイリーヤマザキ）／ペイジー（銀行・ATM払い）</p>' +
      '<p class="rv-paybox__note">※' + PAYNOTE + '。</p>' +
    '</div>';

  function sumHtml(total, compact) {
    var ship = total >= GOAL ? 0 : FEE;
    var shipTxt = ship === 0
      ? '<b class="rv-sum__free">無料</b>'
      : yen(FEE) + '<small>（' + yen(GOAL) + '以上で無料）</small>';
    var h = '';
    if (!compact) h += '<div class="rv-sum__row"><span>商品合計<small>（税込）</small></span><span>' + yen(total) + '</span></div>';
    h += '<div class="rv-sum__row"><span>送料</span><span>' + shipTxt + '</span></div>';
    h += '<div class="rv-sum__row rv-sum__row--total"><span>お支払い合計<small>（税込・送料込み）</small></span><span>' + yen(total + ship) + '</span></div>';
    if (!compact) h += '<p class="rv-sum__note">クーポンコードは次の画面で入力できます</p>';
    return h;
  }

  var TOTAL = null; // カートの合計（税込・自動割引後）。/cart.js から取得

  function setSum(box, compact) {
    var v = String(TOTAL) + (compact ? 'c' : 'p');
    if (box.getAttribute('data-v') === v) return;
    box.setAttribute('data-v', v);
    box.innerHTML = sumHtml(TOTAL, compact);
  }

  // scope の中の .cart__ctas（購入手続きボタン）の前に「送料と合計」、後ろに「安心メモ」を置く
  function mount(scope, compact) {
    var ctas = scope.querySelector('.cart__ctas');
    if (!ctas) return false;
    var fresh = false;
    var box = scope.querySelector('[data-rv-sum]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'rv-sum';
      box.setAttribute('data-rv-sum', '');
      box.setAttribute('role', 'status');
      ctas.parentNode.insertBefore(box, ctas);
      fresh = true;
    }
    setSum(box, compact);
    scope.classList.add('rv-has-sum');
    if (!scope.querySelector('[data-rv-assure]')) {
      var a = document.createElement('div');
      a.setAttribute('data-rv-assure', '');
      a.innerHTML = compact ? ASSURE_DRAWER : ASSURE_PAGE;
      var after = compact ? ctas : (scope.querySelector('.cart__dynamic-checkout-buttons') || ctas);
      after.parentNode.insertBefore(a, after.nextSibling);
    }
    return fresh;
  }

  function unmount(scope) {
    var box = scope.querySelector('[data-rv-sum]');
    if (box) box.remove();
    scope.classList.remove('rv-has-sum');
  }

  function place() {
    document.querySelectorAll('[data-rv-eta]').forEach(function (el) {
      if (el.textContent !== ETA) el.textContent = ETA;
    });
    // コーデページの「お届けまでの流れ」から、日数を書いた「お届け」の段を外す
    document.querySelectorAll('.rv-flow li').forEach(function (li) {
      if (/営業日/.test(li.textContent)) li.remove();
    });
    var hasCart = TOTAL !== null && TOTAL > 0;
    var scopes = [
      [document.querySelector('cart-drawer .drawer__footer'), true],
      [document.querySelector('#main-cart-footer .cart__blocks'), false]
    ];
    scopes.forEach(function (s) {
      if (!s[0]) return;
      if (hasCart) { if (mount(s[0], s[1])) refresh(); }
      else unmount(s[0]);
    });
  }

  var tmr = 0;
  function refresh() {
    clearTimeout(tmr);
    tmr = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { TOTAL = (c && c.total_price ? c.total_price : 0) / 100; place(); })
        .catch(function () {});
    }, 120);
  }

  function init() {
    place();
    refresh();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    } catch (e) {}
    var t = 0, needRefresh = false;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length && !needRefresh; i++) {
        var n = recs[i].target;
        if (n && n.nodeType !== 1) n = n.parentElement;
        if (!n || !n.closest) continue;
        if (n.closest('[data-rv-sum], [data-rv-assure]')) continue;
        if (n.closest('cart-drawer, #main-cart-footer')) needRefresh = true;
      }
      clearTimeout(t);
      t = setTimeout(function () {
        place();
        if (needRefresh) { needRefresh = false; refresh(); }
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
